import { overmind } from '@/overmind';
import Vue from 'vue';
export class UsersGuard {
    // eslint-disable-next-line @typescript-eslint/ban-types
    static async all(to, from, next) {
        // @ts-ignore
        const currentUser = await Vue.auth.user();
        // @ts-ignore
        overmind.actions.users.setCurrentUser(currentUser);
        if (!currentUser) {
            if (currentUser) {
                //@ts-ignore
                const canDisplayWelcomeScreen = 
                //@ts-ignore
                await overmind.actions.users.getDisplayWelcomeScreen(true);
                const authenticatedUserToShowWelcomeScreen = 
                //@ts-ignore
                overmind.actions.users.authenticatedUserToShowWelcomeScreen(true);
                if (canDisplayWelcomeScreen && authenticatedUserToShowWelcomeScreen) {
                    next('/welcome_screen');
                }
            }
        }
        if (currentUser) {
            const canDisplayWelcomeScreen = 
            //@ts-ignore
            await overmind.actions.users.getDisplayWelcomeScreen(true);
            const authenticatedUserToShowWelcomeScreen = 
            //@ts-ignore
            overmind.actions.users.authenticatedUserToShowWelcomeScreen(true);
            if (canDisplayWelcomeScreen && authenticatedUserToShowWelcomeScreen) {
                next('/welcome_screen');
            }
            if (currentUser.email.match('@sankhya.com.br')) {
                if (to.path == '/user/config/api-token-export' &&
                    currentUser.role === 'prospector') {
                    next('/no_found');
                }
                else {
                    next();
                }
            }
            next();
        }
        overmind.actions.infosets.setSearchInfosetsTerm('');
        overmind.actions.infosets.setPage(1);
        if (!overmind.state.filters.saveFilters)
            overmind.actions.filters.resetStateFilters('');
        overmind.actions.search.resetStateSearch();
        overmind.actions.admin.resetState();
        next();
    }
}
